
import type { Candidate } from "@/components/candidates/types";

// Helper function to validate status values
export function validateStatus(status: string | null): Candidate['status'] {
  const validStatuses: Candidate['status'][] = [
    'new', 'contacted', 'screening', 'interview', 'offer', 'hired', 'rejected', 'onhold'
  ];
  
  if (!status || !validStatuses.includes(status as any)) {
    return 'new'; // Default to 'new' if invalid
  }
  
  return status as Candidate['status'];
}

// Helper function to check if a string is a valid UUID
export function isValidUuid(id: string): boolean {
  if (!id) return false; // Ensure id is not null or undefined
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return uuidRegex.test(id);
}

